export async function shouldPromptRequired(type: string): Promise<boolean> {
  return !['group', 'section', 'tabs', 'separator'].includes(type)
}
